export class SearchAutocomplete {
    constructor() {
        this.currentFocus = -1;
    }

    initialize(searchFormElement, searchInputElement, searchClearElement) {
        this.searchForm = searchFormElement;
        this.searchInput = searchInputElement;
        this.searchClear = searchClearElement;
        this._initializeInputListener();
        this._initializeFocusListener();
        this._initializeClearListener();
        this._initializeKeyListener();
        this._initializeClickListener();
    }

    _debounce(func, timeout = 300) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    _initializeInputListener = () => {
        this.searchInput.addEventListener(
            'input',
            this._debounce((e) => this._on_click(e)),
        );
    };
    _initializeClearListener = () => {
        this.searchClear.addEventListener('click', () => {
            this.searchInput.value = '';
            this._hideXButton();
            this.searchInput.focus();
            this._displayRecentQueries(this.searchInput.id, this.searchInput.parentNode);
        });
    };

    _initializeFocusListener = () => {
        this.searchInput.addEventListener('focus', (e) => this._on_click(e));
    };

    _on_click(e) {
        this._closeAllLists();
        const { id, value, parentNode } = e.target;
        this.currentFocus = -1;
        if (value.toLowerCase().length === 0) {
            this._hideXButton();
            this._displayRecentQueries(id, parentNode);
        } else {
            this._showXButton();
            const encodedValue = encodeURIComponent(value.toLowerCase());
            this._displaySuggestions(id, parentNode, encodedValue);
        }
    }

    _initializeKeyListener = () => {
        this.searchInput.addEventListener('keydown', (e) => {
            let dropdown = document.getElementById(this._formatAutocompleteListId(e.target.id));
            if (dropdown) {
                dropdown = dropdown.getElementsByTagName('div');
            }
            if (e.key === 'ArrowDown') {
                this.currentFocus++;
                this._addActive(dropdown);
            } else if (e.key === 'ArrowUp') {
                this.currentFocus--;
                this._addActive(dropdown);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (this.currentFocus > -1) {
                    // simulate click on item and submit form
                    if (dropdown) {
                        dropdown[this.currentFocus].click();
                    }
                }
                this.searchForm.submit();
            }
        });
    };

    _initializeClickListener = () => {
        document.addEventListener('click', (e) => {
            this._closeAllLists(e.target);
        });
    };

    _displayRecentQueries = (id, parentNode) => {
        let suggestionsContainer = this._createSuggestionsContainer(id, parentNode);
        suggestionsContainer.appendChild(this._addHeader('History'));
        const { recentQueryURL } = __SEARCH_CONTEXT__;
        const recentQueriesEndpoint = `${recentQueryURL}`;
        $.get({ url: recentQueriesEndpoint }).then((data) => {
            const { recent_queries: recentQueries } = data;
            if (recentQueries.length === 0) {
                let suggestionItem = document.createElement('div');
                suggestionItem.innerHTML = '0 recent searches';
                suggestionsContainer.appendChild(suggestionItem);
            } else {
                recentQueries.forEach((query) => {
                    const suggestionItem = this._createSuggestion(query, '', 'fa-clock-o');
                    suggestionsContainer.appendChild(suggestionItem);
                });
            }
        });
    };
    _addHeader = (text) => {
        let historyHeader = document.createElement('div');
        historyHeader.innerHTML = text;
        historyHeader.setAttribute('class', 'autocomplete-header');
        return historyHeader;
    };

    _displaySuggestions = (id, parentNode, val) => {
        const suggestionsContainer = this._createSuggestionsContainer(id, parentNode);
        suggestionsContainer.appendChild(this._addHeader('Suggestions'));
        const { suggestionsQueryURL } = __SEARCH_CONTEXT__;
        const suggestionsEndpoint = `${suggestionsQueryURL}?prefix=${val}`;
        $.get({ url: suggestionsEndpoint }).then((data) => {
            const { suggestions } = data;
            suggestions.forEach((suggestion) => {
                const suggestionItem = this._createSuggestion(suggestion, val, 'fa-search');
                suggestionsContainer.appendChild(suggestionItem);
            });
        });
    };

    _createSuggestionsContainer = (id, parentNode) => {
        const suggestionsContainer = document.createElement('div');
        suggestionsContainer.setAttribute('id', this._formatAutocompleteListId(id));
        suggestionsContainer.setAttribute('class', 'search__autocomplete-items');
        parentNode.appendChild(suggestionsContainer);
        return suggestionsContainer;
    };

    _createSuggestion = (suggestion, val, iconClass) => {
        let suggestionItem = document.createElement('div');
        let suggestionItemIcon = document.createElement('span');
        suggestionItemIcon.setAttribute('class', `fa ${iconClass} search-list-item-icon`);
        suggestionItem.appendChild(suggestionItemIcon);
        let suggestionItemText = document.createElement('span');
        suggestionItemText.innerHTML = `<span style="color:#212529">${suggestion.substr(
            0,
            val.length,
        )}</span>${suggestion.substr(val.length)}`;
        suggestionItem.appendChild(suggestionItemText);
        suggestionItem.addEventListener('click', (e) => {
            this._closeAllLists();
            this.searchInput.value = suggestion;
            this.searchForm.submit();
        });
        return suggestionItem;
    };

    _formatAutocompleteListId = (id) => `${id}-autocomplete-list`;

    _addActive = (dropdown) => {
        if (!dropdown) {
            return false;
        }
        this._removeActive(dropdown);
        if (this.currentFocus >= dropdown.length) {
            this.currentFocus = 0;
        }
        if (this.currentFocus < 0) {
            this.currentFocus = dropdown.length - 1;
        }
        dropdown[this.currentFocus].classList.add('search--active');
    };

    _removeActive = (dropdown) =>
        [...dropdown].forEach((element) => {
            element.classList.remove('search--active');
        });

    _closeAllLists = (element) => {
        const items = document.getElementsByClassName('search__autocomplete-items');
        for (let i = 0; i < items.length; i++) {
            if (element !== items[i] && element !== this.searchInput) {
                items[i].parentNode.removeChild(items[i]);
            }
        }
    };

    _showXButton() {
        // for mobile
        if (window.matchMedia('(max-width: 991px)').matches) {
            document.getElementById('clear-input').style.display = 'inline-block';
        }
    }

    _hideXButton() {
        document.getElementById('clear-input').style.display = 'none';
    }
}
